import { css } from 'styled-components';
import {
  getTypography, TypographyName, getSpacing, SpacingName, ThemedFunctor,
} from '@doveit/lego';

export const wrapper: ThemedFunctor = ({
  $minimal,
}) => css`
  ${!$minimal && 'box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);'}
`;

export const header: ThemedFunctor = ({
  theme,
}) => css`
  background-color: ${theme.palettes.brand.primary};
  ${getSpacing.padding(theme, [SpacingName.SMALLER, SpacingName.SMALL])}
`;

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H4)}
  font-weight: 500;
  color: ${theme.palettes.neutrals.lightest};
`;

export const content: ThemedFunctor = ({
  theme,
  $minimal,
}) => css`
  ${!$minimal && getSpacing.padding(theme, SpacingName.SMALL)}

  p {
    ${getTypography(theme, TypographyName.BODY)}
  }
`;

export const reference: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.SMALL)};
  ${getSpacing.padding(theme, [SpacingName.SMALLEST, SpacingName.SMALLER])};
  background-color: ${theme.palettes.brand.primary};
  color: ${theme.palettes.neutrals.lightest};
`;
